import { fetchOrLogout } from "../../../utils/helpers";
import { getBaseUrl } from "../../../utils/requestUtils";

import {
  KitPickupSubmissionResponse,
  NewKitPickupClinicAccount,
  NewKitPickupOrder,
} from "../types";

export const GetAllNewKitPickupLimsAccounts = async (
  token: string,
  setLoggedOut: (inactivity: boolean) => void,
): Promise<NewKitPickupClinicAccount[]> => {
  try {
    const baseUrl = await getBaseUrl();
    const response = await fetchOrLogout(
      `${baseUrl}/api/v1/provider_portal/electronic_orders/lims_id_accounts/`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
      setLoggedOut,
    );

    if (response.ok) {
      const responseData = await response.json();
      return responseData as NewKitPickupClinicAccount[];
    }
    return [];
  } catch (e) {
    return [];
  }
};

export const SubmitNewKitPickup = async (
  token: string,
  payload: NewKitPickupOrder,
  setLoggedOut: (inactivity: boolean) => void,
): Promise<KitPickupSubmissionResponse> => {
  try {
    const baseUrl = await getBaseUrl();
    const response = await fetchOrLogout(
      `${baseUrl}/api/v1/provider_portal/kit_pickup/create_order/`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      },
      setLoggedOut,
    );

    if (response.ok) {
      const responseData = await response.json();
      return responseData as KitPickupSubmissionResponse;
    }
    const errorData = await response
      .json()
      .catch(() => ({ success: "false", confirmation_code: "" }));
    return errorData as KitPickupSubmissionResponse;
  } catch (e) {
    return {
      success: "false",
      confirmation_code: "",
    };
  }
};
